import { WorldAssignmentTrackingConstants } from "@goodgamestudios/world-assignment";
export class ClientFunnelGameStates {
    public static LOADING_CIRCLE: string = "LOADING_CIRCLE";
    public static CLIENT_START: string = "CLIENT_START";
    public static SERVER_CONNECT: string = "SERVER_CONNECT";
    public static SERVER_CONNECT_SUCCESS: string = "SERVER_CONNECT_SUCCESS";
    public static SERVER_CONNECT_ERROR: string = "SERVER_CONNECT_ERROR";
    public static VERSION_CHECK_SEND: string = "VERSION_CHECK_SEND";
    public static VERSION_CHECK_CONFIRMED: string = "VERSION_CHECK_CONFIRMED";
    public static MAINTENANCE_SCREEN: string = "MAINTENANCE_SCREEN";
    public static FIRST_GAME_SCREEN: string = "FIRST_GAME_SCREEN";
    public static REG_LOGIN_FORM: string = "REG_LOGIN_FORM";
    public static GAME_PLAYABLE: string = "GAME_PLAYABLE";
    public static PLAYER_LOGIN: string = "PLAYER_LOGGED_IN";
    public static PLAYER_REGISTERED: string = "REGISTER_PLAYER_ACCOUNT";
    public static NAME_VALIDATION_OK: string = "NAME_VALIDATION_OK";
    public static NAME_VALIDATION_ERROR: string = "NAME_VALIDATION_ERROR";
    public static NAME_VALIDATION_IN_USE: string = "NAME_VALIDATION_IN_USE";
    public static PASSWORD_ENTERED: string = "PASSWORD_ENTERED";
    public static PLAYTIME_0_5_MINUTES: string = "PLAY_TIME_0_5_MINUTES";
    public static PLAYTIME_X_MINUTES_1: string = "PLAY_TIME_1_MINUTES";
    public static PLAYTIME_X_MINUTES_2: string = "PLAY_TIME_2_MINUTES";
    public static PLAYTIME_X_MINUTES_5: string = "PLAY_TIME_5_MINUTES";
    public static PLAYTIME_X_MINUTES_10: string = "PLAY_TIME_10_MINUTES";
    public static PLAYTIME_X_MINUTES_15: string = "PLAY_TIME_15_MINUTES";
    public static PLAYTIME_X_MINUTES_30: string = "PLAY_TIME_30_MINUTES";
    public static PLAYTIME_X_MINUTES_45: string = "PLAY_TIME_45_MINUTES";
    public static PLAYTIME_X_MINUTES_60: string = "PLAY_TIME_60_MINUTES";
    public static TUTORIAL_START: string = "TUTORIAL_START";
    public static TUTORIAL_STEP_1: string = "TUTORIAL_STEP_1";
    public static TUTORIAL_STEP_2: string = "TUTORIAL_STEP_2";
    public static TUTORIAL_STEP_3: string = "TUTORIAL_STEP_3";
    public static TUTORIAL_STEP_4: string = "TUTORIAL_STEP_4";
    public static TUTORIAL_STEP_5: string = "TUTORIAL_STEP_5";
    public static TUTORIAL_STEP_6: string = "TUTORIAL_STEP_6";
    public static TUTORIAL_STEP_7: string = "TUTORIAL_STEP_7";
    public static TUTORIAL_STEP_8: string = "TUTORIAL_STEP_8";
    public static TUTORIAL_STEP_9: string = "TUTORIAL_STEP_9";
    public static TUTORIAL_END: string = "TUTORIAL_END";
    public static LOGIN_COOKIE_READ: string = "LOGIN_COOKIE_READ"; // user has login data and can autologin

    public static FIRST_SESSION_ONLY: any[] = [];

    public static LANG_XML_START: string = "LANG_XML_START";
    public static LANG_XML_END: string = "LANG_XML_END";
    public static ITEM_XML_START: string = "ITEM_XML_START";
    public static ITEM_XML_END: string = "ITEM_XML_END";
    public static ASSETS_START: string = "ASSETS_START";
    public static ASSETS_END: string = "ASSETS_END";

    public static LOADING_BAR: string = "LOADING_BAR";
    public static GAME_SWF_LOADED: string = "GAME_SWF_LOADED";

    public static AVATAR_CREATION_STARTED: string = "AVATAR_CREATION_STARTED";
    public static AVATAR_CREATION_FINISHED: string = "AVATAR_CREATION_FINISHED";
    public static VIEW_AGB: string = "VIEW_AGB";
    public static HAS_ALREADY_LOGIN_DATA: string = "HAS_ALREADY_LOGIN_DATA";
    public static GAME_JOINED: string = "GAME_JOINED";

    //TODO: This const will be deleted after implementing of SSO-Events in our games
    public static CLICK_REGISTER: string = "CLICK_REGISTER";

    // Constants for the first instance tracking events, which are used to control interface loading process.
    public static JOINED_STARTSCREEN: string = "JOINED_STARTSCREEN";
    public static INTERFACE_LOADED_REGISTRATION: string = "INTERFACE_LOADED_REGISTRATION";
    public static INTERFACE_LOADED_ISOWORLD: string = "INTERFACE_LOADED_ISOWORLD";

    // Constants, which are used by start- and registerscreen tracking events:

    // register
    public static ERROR_CLICK_REGISTER_WITHOUT_DATA: string = "ERROR_CLICK_REGISTER_WITHOUT_DATA";
    public static CLICK_REGISTER_WITH_DATA: string = "CLICK_REGISTER_WITH_DATA";
    public static REGISTERED: string = "REGISTERED";

    // name
    public static ENTER_NAME: string = "ENTER_NAME";
    public static ERROR_NAME_EMPTY: string = "ERROR_NAME_EMPTY";
    public static ERROR_NAME_EXISTS: string = "ERROR_NAME_EXISTS";
    public static ERROR_NAME_INVALID: string = "ERROR_NAME_INVALID";
    public static ERROR_NAME_BADWORD: string = "ERROR_NAME_BADWORD";
    public static ERROR_NAME_TOO_SHORT: string = "ERROR_NAME_TOO_SHORT";
    public static ERROR_NAME_DIALOG_CHOOSE_NAME: string = "ERROR_NAME_DIALOG_CHOOSE_NAME";
    public static PICKED_SUGGESTED_USERNAME: string = "PICKED_SUGGESTED_USERNAME";

    //e-mail
    public static ENTER_EMAIL: string = "ENTER_EMAIL";
    public static ERROR_MAIL_EMPTY: string = "ERROR_MAIL_EMPTY";
    public static ERROR_MAIL_EXISTS: string = "ERROR_MAIL_EXISTS";
    public static ERROR_MAIL_TOO_SHORT: string = "ERROR_MAIL_TOO_SHORT";
    public static ERROR_MAIL_INVALID: string = "ERROR_MAIL_INVALID";

    // password
    public static ENTER_PASSWORD: string = "ENTER_PASSWORD";
    public static ERROR_PASS_EMPTY: string = "ERROR_PASS_EMPTY";
    public static ERROR_PASS_TOO_SHORT: string = "ERROR_PASS_TOO_SHORT";
    public static ERROR_PASS_INVALID: string = "ERROR_PASS_INVALID";

    // login
    public static LOGIN_ERROR: string = "LOGIN_ERROR";
    public static ERROR_INVALID_LOGIN_FIELD: string = "ERROR_INVALID_LOGIN_FIELD";
    public static ERROR_LOGIN_NAME: string = "ERROR_LOGIN_NAME";
    public static ERROR_LOGIN_PASSWORD: string = "ERROR_LOGIN_PASSWORD";
    public static LOGIN_ENTER_NAME: string = "LOGIN_ENTER_NAME";
    public static LOGIN_ENTER_PASSWORD: string = "LOGIN_ENTER_PASSWORD";
    public static LOGIN_CLICKED: string = "LOGIN_CLICKED";

    // server / county-detection
    public static COUNTRY_SELECTION: string = "COUNTRY_SELECTION";
    public static COUNTRY_CHANGED: string = "COUNTRY_CHANGED";
    public static SERVER_SELECTION: string = "SERVER_SELECTION";
    public static SERVER_CHANGED: string = "SERVER_CHANGED";

    // SSO
    public static ERROR_CLICK_REGISTER_WITHOUT_DATA_SSO: string = "ERROR_CLICK_REGISTER_WITHOUT_DATA_SSO";
    public static CLICK_REGISTER_WITH_DATA_SSO: string = "CLICK_REGISTER_WITH_DATA_SSO";

    // Server errors
    public static ERROR_SERVER_CONNECT: string = "ERROR_SERVER_CONNECT";
    public static ERROR_SERVER_CONNECT_TIMEOUT: string = "ERROR_SERVER_CONNECT_TIMEOUT";

    // these are actually dispacthed by WorldAssignment
    public static NETWORK_XML_START: string = WorldAssignmentTrackingConstants.NETWORK_XML_START;
    public static NETWORK_XML_END: string = WorldAssignmentTrackingConstants.NETWORK_XML_END;

    private static WorldAssignmentStates = [
        WorldAssignmentTrackingConstants.ZONE_XML_START,
        WorldAssignmentTrackingConstants.ZONE_XML_END,
        WorldAssignmentTrackingConstants.BRANCH_XML_START,
        WorldAssignmentTrackingConstants.BRANCH_XML_END,
        WorldAssignmentTrackingConstants.COUNTRY_XML_START,
        WorldAssignmentTrackingConstants.COUNTRY_XML_END
    ];

    // TODO @HTML5   IMPLEMENTATION IN EMPIRE WAS DIFFERENT...
    /* Mandatory tracking states for client funnel tracking. Additionally tutorial steps are sent as tracking steps,
     * as well as most of the CommonGameStates.
     */
    //public static FIRST_SESSION_ONLY: any[] = [ClientFunnelGameStates.TUTORIAL_START, ClientFunnelGameStates.TUTORIAL_END];
}

